export default {
  title: 'Domeniul magazinului',
  description:
    'Publicați magazinele online ale restaurantelor dvs. pe un domeniu propriu în locul adresei comune — de exemplu pizza-mario.comenzi-marcadvs.ro. Adăugați o singură dată două înregistrări DNS; fiecare restaurant adăugat ulterior își primește adresa automat.',
  read_only_description:
    'Domeniul pe care sunt publicate magazinele restaurantelor acestui partener. Doar partenerul îl poate conecta sau modifica.',
  read_only_empty: 'Acest partener nu a conectat niciun domeniu de magazin.',
  not_connected: {
    label: 'Domeniu pentru magazinele restaurantelor dvs.',
    hint: 'Un domeniu sau subdomeniu care vă aparține, de exemplu comenzi-marcadvs.ro. Trebuie să fie un alt domeniu decât cel pe care rulează aplicațiile echipei dvs. — nu un subdomeniu al acestuia.',
    placeholder: 'comenzi-marcadvs.ro',
    connect: 'Conectați',
  },
  status: {
    pending_dns: 'Se așteaptă DNS',
    active: 'Activ',
    failed: 'Acțiune necesară',
    disabled: 'Deconectat',
  },
  primary_badge: 'Principal',
  summary: {
    pending: 'Așteptăm înregistrările dvs. DNS. De obicei durează câteva minute, uneori câteva ore.',
    failed:
      'Nu am putut confirma la timp toate înregistrările. Corectați înregistrarea marcată mai jos, apoi apăsați Verificați din nou — de acolo reluăm verificările.',
    failed_leave: 'Pentru a conecta alt domeniu, deconectați mai întâi acesta.',
    live: '{{host}} este activ.',
    primary: 'Fiecare restaurant nou își primește automat adresa pe acest domeniu.',
    standby:
      'Setați-l ca principal pentru ca fiecare restaurant nou să îl primească automat. Restaurantele aflate deja pe alt domeniu rămân unde sunt.',
    regressed:
      '{{host}} este activ, dar o înregistrare de mai jos nu mai este confirmată. Magazinele dvs. sunt în continuare online — corectați înregistrarea la furnizorul dvs. DNS.',
  },
  instructions: {
    title: 'Cum adăugați înregistrările',
    step_provider:
      'Autentificați-vă acolo unde este administrat DNS-ul pentru {{root}} — de obicei la furnizorul de la care ați cumpărat domeniul.',
    step_add: 'Adăugați fiecare înregistrare de mai jos exact așa cum este afișată: tipul, numele și valoarea.',
    step_check: 'Salvați, apoi faceți clic pe „{{button}}”. Continuăm și noi să verificăm.',
    tip_name:
      'Majoritatea furnizorilor vor în câmpul de nume doar partea dinaintea {{root}} — _foodamigos-verify și *. Numele complet este afișat dedesubt, pentru furnizorii care îl cer.',
    tip_wildcard:
      'Înregistrarea * trimite fiecare adresă de sub {{root}} către magazinele dvs., așa că nu trebuie să adăugați niciodată câte o înregistrare pentru fiecare restaurant.',
    tip_existing:
      'Înregistrările existente pentru {{root}}, de exemplu pentru site-ul dvs., e-mail sau www, funcționează în continuare: înregistrarea * răspunde doar pentru numele care nu au o înregistrare proprie. Dacă {{root}} are deja o înregistrare *, înlocuiți-o cu a noastră.',
    tip_cloudflare: 'În Cloudflare, setați înregistrarea CNAME pe „Doar DNS” (nor gri), altfel nu o putem vedea.',
  },
  records: {
    title: 'Adăugați aceste înregistrări DNS pentru {{root}} la furnizorul dvs. de domeniu',
  },
  example: 'Un restaurant va fi atunci la o adresă precum {{host}}.',
  example_label: 'restaurantul-dvs',
  buttons: {
    check_again: 'Verificați din nou',
    make_primary: 'Setați ca principal',
    unlink: 'Deconectați',
    retry: 'Încercați din nou',
  },
  primary_unavailable: 'Disponibil după ce domeniul este activ.',
  unlink_blocked_one:
    '{{count}} restaurant este încă pe acest domeniu. Mutați-l pe alt domeniu înainte de deconectare.',
  unlink_blocked_few:
    '{{count}} restaurante sunt încă pe acest domeniu. Mută-le pe un alt domeniu înainte de deconectare.',
  unlink_blocked_other:
    '{{count}} restaurante sunt încă pe acest domeniu. Mutați-le pe alt domeniu înainte de deconectare.',
  unlink_confirm: {
    title: 'Deconectați {{host}}?',
    description: 'Puteți conecta {{host}} din nou mai târziu.',
    description_primary:
      'Restaurantele noi primesc din nou o adresă pe domeniul comun. Puteți conecta {{host}} din nou mai târziu.',
    ok: 'Deconectați',
  },
  toasts: {
    load_error: 'Nu s-a putut încărca domeniul magazinului dvs.',
    load_error_read_only: 'Nu s-a putut încărca domeniul magazinului acestui partener',
    connected: 'Domeniu conectat — adăugați acum înregistrările de mai jos',
    connect_failed: 'Nu s-a putut conecta domeniul',
    check_started: 'Se verifică din nou…',
    check_failed: 'Nu s-a putut porni verificarea. Încercați din nou peste un minut.',
    primary_set: 'Restaurantele noi primesc acum acest domeniu',
    primary_failed: 'Nu s-a putut seta acest domeniu ca principal',
    unlinked: 'Domeniu deconectat',
    unlink_failed: 'Nu s-a putut deconecta domeniul',
    unlink_has_restaurants_one:
      '{{count}} restaurant este încă pe {{host}}: {{names}}. Mutați-l pe alt domeniu înainte de deconectare.',
    unlink_has_restaurants_few:
      '{{count}} restaurante sunt încă pe {{host}}: {{names}}. Mută-le pe un alt domeniu înainte de deconectare.',
    unlink_has_restaurants_other:
      '{{count}} restaurante sunt încă pe {{host}}: {{names}}. Mutați-le pe alt domeniu înainte de deconectare.',
    gone: '{{host}} nu mai este conectat — este posibil să fi fost deconectat într-o altă filă.',
  },
};
